import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.scss'

const AgentTile = (props) => {
  const {
    agent: {
      full_name, email, mobile, agent_title,
    },
  } = props

  return (
    <div className={styles.root}>
      <div className={styles.details}>
        <span className={styles.name}>{full_name}</span>
        <span className={styles.position}>{agent_title}</span>
        <span className={styles.email}>{email}</span>
        <span className={styles.mobile}>{mobile}</span>
      </div>
    </div>
  )
}

AgentTile.propTypes = {
  agent: PropTypes.object.isRequired,
}

export default AgentTile
